import RallyPinboard from '@/pages/RallyPinboard'

/**
 * Rally tab inside the nominee portal.
 * Reuses the existing RallyPinboard page component directly.
 */
export default function NomineeRally() {
  return (
    <div className="-mx-4">
      <RallyPinboard />
    </div>
  )
}
